import login from "@/mods/user/dialog/login";

export default {
  login,
};
